var Application, Chaplin, config, routes, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

Chaplin = require('chaplin');

routes = require('routes');

config = require('config');

module.exports = Application = (function(_super) {
  __extends(Application, _super);

  function Application() {
    _ref = Application.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  Application.prototype.title = 'Virtual Catalog';

  Application.prototype.initialize = function() {
    Application.__super__.initialize.apply(this, arguments);
    this.initAjaxSetup();
    this.initRouter(routes);
    this.initDispatcher({
      controllerSuffix: '-controller'
    });
    this.initLayout();
    this.initComposer();
    this.initMediator();
    this.startRouting();
    this.initResizeReload();
    return typeof Object.freeze === "function" ? Object.freeze(this) : void 0;
  };

  Application.prototype.initMediator = function() {
    Chaplin.mediator.catalogue = null;
    Chaplin.mediator.bookmarks = null;
    Chaplin.mediator.notes = null;
    return Chaplin.mediator.seal();
  };

  Application.prototype.initAjaxSetup = function() {
    return $.ajaxSetup({
      beforeSend: function(jqXHR, settings) {
        return settings.url = "" + (config.localData ? config.api.testData + '/1876.json?' : config.api.root) + settings.url;
      },
      crossDomain: true
    });
  };

  Application.prototype.initResizeReload = function() {
    var _this = this;
    return window.addEventListener('orientationchange', function() {
      return window.location.href = window.location.href;
    });
  };

  return Application;

})(Chaplin.Application);
